export default {
  slogan: "Simplify your life, wash your hands, and don't memorize links",
  shortUrl: {placeholder: 'http://very-long-url-to-short.com'},
  customCode: {placeholder: 'my-custome-name'},
  errors: {
    apiFail: 'There was an error, try again! Maybe!',
    urlInvalid: 'Url is invalid',
  },
}
